<template>
  <div>
    <div class="ft-alert-success" v-if="successMsg"><i class="fas fa-check-circle"></i> {{ successMsg }}</div>

    <div class="ft-card">
      <div class="ft-card-header-row">
        <h3 class="ft-card-title"><i class="fas fa-briefcase"></i> Job Openings</h3>
        <router-link to="/admin/careers/create" class="ft-btn"><i class="fas fa-plus"></i> New Opening</router-link>
      </div>

      <form class="ft-filter-form" @submit.prevent="load(1)">
        <div class="ft-field">
          <label>Status</label>
          <select v-model="filters.status">
            <option value="">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div class="ft-field" style="min-width:220px;">
          <label>Search Position</label>
          <input type="text" v-model="filters.search">
        </div>
        <div class="ft-field">
          <button type="submit" class="ft-btn"><i class="fas fa-filter"></i> Filter</button>
        </div>
        <div class="ft-field">
          <button type="button" class="ft-btn ft-btn-outline" @click="resetFilters"><i class="fas fa-undo"></i> Reset</button>
        </div>
      </form>

      <div class="ft-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Position</th>
              <th>Department</th>
              <th>Level</th>
              <th>Location</th>
              <th>Status</th>
              <th>Posted</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in positions" :key="row.id">
              <td>{{ row.position }}</td>
              <td>{{ row.department || '-' }}</td>
              <td>{{ row.level || '-' }}</td>
              <td>{{ row.location || '-' }}</td>
              <td><span class="ft-badge" :class="row.status === 'active' ? 'ft-badge-approved' : 'ft-badge-rejected'">{{ row.status }}</span></td>
              <td>{{ formatDate(row.created_at) }}</td>
              <td class="ft-action-cell">
                <router-link :to="'/admin/careers/'+row.id+'/edit'" class="ft-btn ft-btn-sm ft-btn-outline"><i class="fas fa-pencil-alt"></i> Edit</router-link>
                <button class="ft-btn ft-btn-sm ft-btn-danger" @click="remove(row.id)"><i class="fas fa-trash"></i> Delete</button>
              </td>
            </tr>
            <tr v-if="!positions.length"><td colspan="7">
              <div class="ft-empty-state"><i class="fas fa-briefcase"></i> No job openings yet.</div>
            </td></tr>
          </tbody>
        </table>
      </div>

      <div class="ft-pagination">
        <button :disabled="page <= 1" @click="load(page - 1)"><i class="fas fa-chevron-left"></i></button>
        <span class="ft-page-info">Page {{ page }} of {{ lastPage }}</span>
        <button :disabled="page >= lastPage" @click="load(page + 1)"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import career from '@/services/adminCareer.service';
import Api from '@/helpers/adminApi';
import moment from 'moment';

export default {
  name: 'AdminCareer',
  data() {
    return {
      positions: [],
      page: 1,
      lastPage: 1,
      filters: { status: '', search: '' },
      successMsg: '',
    };
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page) {
      this.page = page;
      let context = this;
      Api(context, career.index({ ...this.filters, page })).onSuccess(function (response) {
        context.positions = response.data.data.data;
        context.lastPage = response.data.data.last_page;
      }).call();
    },
    resetFilters() {
      this.filters = { status: '', search: '' };
      this.load(1);
    },
    remove(id) {
      if (!confirm('Delete this job opening?')) return;
      let context = this;
      Api(context, career.delete(id)).onSuccess(function () {
        context.successMsg = 'Job opening deleted.';
        context.load(context.page);
        setTimeout(() => { context.successMsg = ''; }, 3000);
      }).call();
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
};
</script>
